/* @ngInject */

export default class LoginCtrl {
	constructor(
		$scope,
		$state,
		Utility,
		$window,
		$timeout,
		$rootScope,
		NavigationService,
		LocalStorageService,
		NotificationService,
		AuthenticationService
	) {
		'ngInject';
		this.$scope = $scope;
		this.$state = $state;
		this.Utility = Utility;
		this.$window = $window;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.NavigationService = NavigationService;
		this.LocalStorageService = LocalStorageService;
		this.NotificationService = NotificationService;
		this.AuthenticationService = AuthenticationService;

		this.init();
	}

	init() {
		this.$rootScope.$broadcast('user-login-busy', {
			isBusy: true,
			err: null
		});

		this.Password = undefined;
		this.UserName = undefined;
		this.resetToken = undefined;
		this.wantToRegister = undefined;
		this.dontAskMeAgain = undefined;
		this.isRegisterFormValid = false;
		this.ConfirmPassword = undefined;

		this.Utility.loadLoader();

		this.isBusy = false;
		this.timeBetweenModals = 680;

        this._handleEvents();
        this.passwordFieldType = 'password';
        this.isNotificationListenerRegistered = false;
		this.NavigationService.InitialiseNavigation().then(() => {
			this.$rootScope.$broadcast('user-login-busy', {
				isBusy: false,
				err: null
			});
			const currentUser = this.AuthenticationService.currentUser();
			if (currentUser) {
				this.$rootScope.$broadcast('user-logged-in', currentUser);
			}

		});


	}

	change(evt) {
		this.isRegisterFormValid =
			this.FirstName &&
			this.LastName &&
			this.Password &&
			this.ConfirmPassword &&
			this.Password === this.ConfirmPassword;
	}

	continue(evt) {
		this.closeRegisterPromptModal();

		if (this.wantToRegister) {
			const user = this.AuthenticationService.currentUser();
			this.UserName = user.UserName;
			this.$timeout(() => {
				this.showRegisterModal();
			}, timeBetweenModals);
		} else if (this.dontAskMeAgain) {
			this.AuthenticationService
				.dontShowRegisterPrompt()
				.then(
					(results) => { },
					(err) => {
						console.error('Error while opting out of the register reminder: ' + this.UserName, err);
					}
				)
				.finally(() => {
					this.init();
				});
		}
	}

	register() {
		const payLoad = {
			UserName: this.UserName,
			Password: this.Password,
			FirstName: this.FirstName,
			LastName: this.LastName
		};

		this.isBusy = true;
		this.AuthenticationService
			.registerUser(payLoad)
			.then(
				(results) => {
					if (results.WasSuccessful) {
						this.NotificationService.success('REGISTERED SUCCESSFULLY');
					} else {
						this.NotificationService.error('REGISTRATION UNSUCCESSFUL');
					}
				},
				(err) => {
					console.error('Error while registering user: ' + this.UserName, err);
					this.NotificationService.error('REGISTRATION UNSUCCESSFUL');
				}
			)
			.finally(() => {
				this.init();
				this.isBusy = true;
				this.closeRegisterModal();
			});
	}

	async login(evt, shouldRedirect) {
        this.isLoginBusy = true;
        try {
            const results = await this.AuthenticationService.loginUser(this.UserName, this.Password);

            if (typeof results === 'object' && results.length === 2) {
                if (shouldRedirect) {
                    this.$state.go('dashboard');
                }
            } else {
                this.NotificationService.success('LOGIN UNSUCCESSFUL');
                this.isNotificationListenerRegistered = true;
            }
        } catch (err) {
            this.NotificationService.error('LOGIN UNSUCCESSFUL');
            const payLoad = {
                isBusy: false,
                err: null
            };
            this.isNotificationListenerRegistered = true;
			this.$rootScope.$broadcast('user-login-busy', payLoad);
			console.error(`Error while logging in user: ${this.UserName}\nError: ${err}`);
		} finally {
			this.init();
			this.isLoginBusy = false;
		}
	}

	preRegisterUser() {
		this.$state.go('register');
	}
	
	preShowForgotPasswordModal() {
		this.$timeout(() => {
			this.UserName = '';
			this.showForgotPasswordModal();
		}, this.timeBetweenModals - 300);
	}

	forgotPassword(userName = null) {
		this.isBusy = true;
		const promise = this.AuthenticationService.userForgotPassword(userName || this.UserName);
		promise.finally(() => {
			this.$timeout(() => {
				promise
					.then(
						(results) => {
							this.NotificationService.success('FOLLOW THE EMAIL LINK TO SET A NEW PASSWORD');
						},
						(err) => {
							console.error(`Error while resetting a password: ${err}`);

							this.NotificationService.error('PASSWORD RESET FAILED');
						}
					)
					.finally(() => {
						this.init();
						this.isBusy = false;
						this.closeForgotPasswordModal();
					});
			}, 1200);
		});
	}

	resetPassword() {
		this.isBusy = true;

		const promise = this.AuthenticationService.userResetPassword(this.Password, this.resetToken);
		promise.finally(() => {
			this.$timeout(() => {
				promise
					.then(
						(results) => {
							this.NotificationService.success('PASSWORD RESET SUCCESSFULLY');							
						},
						(err) => {
							this.NotificationService.error('FAILED. PLEASE CONTACT PRETOR GROUP.');
						}
					)
					.finally(() => {
						this.init();
						this.isBusy = false;
						this.closeRestPasswordModal();
					});
			}, 1200);
		});
	}

	closeUnsubscribe() {
		this.AuthenticationService.unsubscribeMonthlyFinancialDocs().then(
			(results) => {
				this.NotificationService.success('UNSUBSCRIBED SUCCESSFULLY');
			},
			(err) => {
				this.NotificationService.error('UNSUBSCRIBE FAILED');
				console.error(err);
			}
		);
		this.closeUnsubscribeMonthlyFinancialDocs();
    }

    togglePasswordVisibility() {
        this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
    };

	_handleEvents() {

		this.$rootScope.$on('auth-modal-set-username', (event, username) => {
			this.UserName = username;
		})

		this.$scope.$on('reset-user-password', ($evt, userName) => {
			this.forgotPassword(userName);
		});

		this.$scope.$on('unsubscribe-monthly-financial-docs', ($event) => {
			this.showUnsubscribeMonthlyFinancialDocs();
		});

		this.$scope.$on('show-login-auth-modal', (event) => {
			//this.showLoginModal();
		});

		this.$scope.$on('show-reset-password-auth-modal', ($event, token) => {
			this.resetToken = token;
			this.LocalStorageService.save('resetPasswordToken', token);
			this.showRestPasswordModal();
		});

		this.$scope.$on('user-logged-in', ($event, results) => {
			const profile = results && results.length > 0 ? results[1] : results;
			if (profile) {
				this.$state.go('dashboard');
			}
		});

        if (!this.isNotificationListenerRegistered) {
            this.$rootScope.$on('show-notification', ($event, message, error, timeout) => {
                if (!$event.defaultPrevented) {
                    $event.defaultPrevented = true;
                }
                this.$rootScope.$broadcast('notifications-modal-show', { message, error, timeout });
            });
            this.isNotificationListenerRegistered = true;
        }

		this.$rootScope.$on('user-reset-password', (event, data) => {
			this.preShowForgotPasswordModal();
		});
	}
}
